var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35239",
    "data-name": "Group 35239",
    transform: "translate(-757.7 -295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9815",
    "data-name": "Rectangle 9815",
    width: 40,
    height: 40,
    transform: "translate(757.7 295)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35291",
    "data-name": "Group 35291",
    transform: "translate(760.7 299.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72310",
    "data-name": "Path 72310",
    d: "M88,44.773V51.4m0,6.626h.016m-2.31-21.712L72.083,59.843c-.756,1.305-1.134,1.958-1.078,2.493a1.656,1.656,0,0,0,.673,1.168c.436.317,1.19.317,2.7.317h27.247c1.508,0,2.262,0,2.7-.317a1.656,1.656,0,0,0,.673-1.168c.056-.536-.322-1.188-1.078-2.493L90.293,36.312c-.753-1.3-1.129-1.951-1.62-2.169a1.657,1.657,0,0,0-1.346,0C86.836,34.361,86.459,35.012,85.707,36.312Z",
    transform: "translate(-71 -34)",
    fill: "none",
    stroke: "#ef6863",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.dc0ad5803f3d2196e62ca9bd6eb0987d.svg";
export { ForwardRef as ReactComponent };